/* Chat "Trova il tuo profumo": Yassine AI.
   Quattro domande a scelta, poi i profumi veri del negozio presi dalle collezioni (/collections/<handle>?view=chat).
   Consiglia sei profumi alla volta, "Mostrami altri" fa vedere i successivi, e se si tocca di nuovo la stessa cosa Yassine lo fa notare. */
(function () {
  var pannello = document.querySelector('[data-ap-chat-pannello]');
  if (!pannello) return;
  var msgs = pannello.querySelector('[data-ap-chat-msgs]');
  var foto = pannello.querySelector('.ap-chat__avatar img').src;
  var giro = 0, avviata = false, ultimoAttivo = null, ultimoBot = false;
  var stato, visti = {}, cache = {}, ricordo = { combinazioni: {} };

  var PER_VOLTA = 6;
  var GUSTI = {
    'Dolce e vanigliato': { col: ['profumi-vaniglia', 'profumi-gourmand'], dice: 'dolce e vanigliato' },
    'Oud e legni': { col: ['profumi-oud', 'profumi-legnosi'], dice: 'oud e legni' },
    'Fresco e agrumato': { col: ['freschezza-orientale'], dice: 'fresco' },
    'Fiorito e rosa': { col: ['profumi-rosa', 'profumi-floreale'], dice: 'fiorito' },
    'Speziato e incenso': { col: ['profumi-speziato', 'profumi-incenso'], dice: 'speziato' },
    'Ambrato e muschiato': { col: ['profumi-ambrato', 'profumi-muschiato'], dice: 'caldo e ambrato' },
    'Senza alcol, attar': { col: ['oli-essenziale'], dice: 'attar senza alcol' },
    'Non lo so, voglio provare': { col: ['i-piu-venduti-collezione-unisex', 'mini-e-viaggio'], dice: 'da provare' }
  };
  var CHI = {
    'Per me, uomo': { col: 'profumi-da-uomo', no: 'profumo-da-donna', dice: 'per lui' },
    'Per me, donna': { col: 'profumo-da-donna', no: 'profumi-da-uomo', dice: 'per lei' },
    'Va bene per tutti': { col: 'profumi-arabi-unisex', dice: 'unisex' },
    'È un regalo': { col: 'idee-regalo', dice: 'ottimo da regalare' }
  };
  var QUANDO = {
    'Tutti i giorni': { col: 'profumi-ogni-giorno', dice: 'per tutti i giorni' },
    'In ufficio': { col: 'profumi-ufficio', dice: "giusto per l'ufficio" },
    "D'estate": { col: 'profumi-estate', dice: "per l'estate" },
    "D'inverno e la sera": { col: 'profumi-inverno', dice: "per l'inverno" },
    'Non importa': null
  };
  var BUDGET = {
    'Sotto 50 euro': [0, 5000],
    'Tra 50 e 100 euro': [5000, 10000],
    'Oltre 100 euro': [10000, 1e9],
    'Non importa': null
  };
  var GIA = [
    'Me l\'hai già chiesto 😄 Quelli che ti ho consigliato sono ancora lì sopra.',
    'Stessa domanda, stessa risposta: sono quelli che ti ho già consigliato 😉',
    'Ti vedo indeciso! Guarda bene quelli sopra, te li ho già scelti io.',
    'Ancora? Allora è proprio la tua strada 😄 Te li ho già messi sopra.'
  ];

  var MANO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 11V5a2 2 0 0 1 4 0v5"/><path d="M13 10a2 2 0 0 1 4 0v1a2 2 0 0 1 4 0v3a7 7 0 0 1-7 7h-1a7 7 0 0 1-6-3.5L4.5 14a1.8 1.8 0 0 1 3-2L9 14"/></svg>';
  var CARRELLO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L21 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>';
  var SPUNTA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function euro(cent) { var n = cent / 100; return n.toLocaleString('it-IT', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; }
  function attesa(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function giu() { msgs.scrollTop = msgs.scrollHeight; }
  function aggiungi(el) { msgs.appendChild(el); giu(); return el; }
  function mescola(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function aCaso(a) { return a[Math.floor(Math.random() * a.length)]; }

  /* prende i profumi di una collezione, una volta sola */
  function collezione(h) {
    if (cache[h]) return cache[h];
    var url = '/collections/' + h + '?view=chat';
    if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') url += '&preview_theme_id=' + Shopify.theme.id;
    /* niente intestazione Accept JSON: Shopify risponderebbe con i dati della collezione invece che con la vista chat */
    cache[h] = fetch(url)
      .then(function (r) { return r.ok ? r.text() : '[]'; })
      .then(function (t) { try { var d = JSON.parse(t); return Array.isArray(d) ? d : []; } catch (e) { return []; } })
      .catch(function () { return []; });
    return cache[h];
  }

  function io(testo) {
    ultimoBot = false;
    var d = document.createElement('div'); d.className = 'ap-chat__msg ap-chat__msg--io'; d.textContent = testo;
    return aggiungi(d);
  }
  function bot(html, ms, mio) {
    var riga = document.createElement('div');
    riga.className = 'ap-chat__riga' + (ultimoBot ? ' ap-chat__riga--dopo' : '');
    riga.innerHTML = '<img class="ap-chat__mini" src="' + foto + '" alt=""><div class="ap-chat__scrive"><i></i><i></i><i></i></div>';
    aggiungi(riga);
    return attesa(ms || 650).then(function () {
      if (mio !== giro) { riga.remove(); return Promise.reject('fermo'); }
      riga.lastChild.remove();
      var d = document.createElement('div'); d.className = 'ap-chat__msg ap-chat__msg--bot'; d.innerHTML = html;
      riga.appendChild(d); ultimoBot = true; giu(); return riga;
    });
  }
  function scelte(voci, fn, griglia) {
    var t = document.createElement('p'); t.className = 'ap-chat__tocca'; t.innerHTML = MANO + 'Tocca una risposta';
    var d = document.createElement('div'); d.className = 'ap-chat__scelte' + (griglia ? ' ap-chat__scelte--griglia' : '');
    voci.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ap-chat__scelta'; b.textContent = v;
      b.addEventListener('click', function () { t.remove(); d.remove(); io(v); fn(v); });
      d.appendChild(b);
    });
    aggiungi(t); aggiungi(d);
  }

  /* costruisce la classifica dei profumi per le risposte date */
  function classifica() {
    var g = GUSTI[stato.gusto], c = CHI[stato.chi], q = QUANDO[stato.quando];
    var lista = g.col.slice();
    if (c) { lista.push(c.col); if (c.no) lista.push(c.no); }
    if (q) lista.push(q.col);
    lista.push('i-piu-venduti-collezione-unisex');
    return Promise.all(lista.map(collezione)).then(function (tutte) {
      var dentro = {}; lista.forEach(function (h, i) { dentro[h] = {}; if (!Array.isArray(tutte[i])) tutte[i] = []; tutte[i].forEach(function (p) { dentro[h][p.h] = 1; }); });
      var pool = {};
      var nomi = {};
      g.col.forEach(function (h) { (tutte[lista.indexOf(h)] || []).forEach(function (p) { var n = (p.m + ' ' + p.n).toLowerCase(); if (nomi[n] && nomi[n] !== p.h) return; nomi[n] = p.h; pool[p.h] = p; }); });
      var b = BUDGET[stato.budget];
      var righe = Object.keys(pool).map(function (k) {
        var p = pool[k], s = 0, perche = [];
        var nGusti = g.col.filter(function (h) { return dentro[h][k]; }).length;
        s += nGusti * 3; perche.push(g.dice);
        if (c) {
          if (dentro[c.col][k]) { s += 3; perche.push(c.dice); }
          if (c.no && dentro[c.no][k] && !dentro[c.col][k]) s -= 8;
        }
        if (q && dentro[q.col][k]) { s += 2; perche.push(q.dice); }
        if (dentro['i-piu-venduti-collezione-unisex'][k]) { s += 1.5; perche.push('tra i più venduti'); }
        if (p.c > p.p) s += 0.5;
        var nelBudget = !b || (p.p >= b[0] && p.p < b[1]);
        if (b && nelBudget) perche.push(stato.budget.toLowerCase());
        return { p: p, s: s + Math.random() * 1.2, ok: nelBudget, perche: perche };
      });
      var buone = righe.filter(function (r) { return r.ok && r.s > -2; });
      if (buone.length < PER_VOLTA) buone = buone.concat(righe.filter(function (r) { return !r.ok && r.s > -2; }));
      return buone.sort(function (a, b) { return b.s - a.s; });
    });
  }

  function aggiornaIcona() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('cart-icon').forEach(function (el) { if (el.renderCartBubble) el.renderCartBubble(c.item_count); });
    }).catch(function () {});
  }
  function metti(btn, p, mio) {
    if (btn.hasAttribute('data-fatto')) {
      bot(aCaso(['Ce l\'hai già nel carrello 😉', 'Già messo! Se vuoi ne aggiungo un altro dalla scheda.', 'Quello è già nel carrello, tranquillo.']), 400, mio).catch(function () {});
      return;
    }
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: p.v, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        btn.disabled = false; btn.setAttribute('data-fatto', ''); btn.innerHTML = SPUNTA; btn.setAttribute('aria-label', 'Già nel carrello');
        aggiornaIcona();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ap-chat' } } }));
        return bot('Fatto, <b>' + esc(p.n) + '</b> è nel carrello.', 450, mio).then(function () {
          scelte(['Vai al carrello', 'Continua a guardare'], function (v) { if (v === 'Vai al carrello') { if (window.apCarrello) window.apCarrello.apri(); else window.location.href = '/cart'; } });
        });
      })
      .catch(function (e) {
        btn.disabled = false;
        if (e !== 'fermo') bot('Non sono riuscito ad aggiungerlo. Aprilo dalla scheda e riprova da lì.', 400, mio).catch(function () {});
      });
  }

  function mostraCarte(righe, mio) {
    var box = document.createElement('div'); box.className = 'ap-chat__consigli';
    righe.forEach(function (r) {
      var p = r.p, off = p.c > p.p ? Math.round((1 - p.p / p.c) * 100) : 0;
      visti[p.h] = 1;
      var motivo = r.perche.filter(function (x, i, a) { return x && a.indexOf(x) === i; }).slice(0, 2).join(', ');
      var art = document.createElement('div'); art.className = 'ap-chat__prod';
      art.innerHTML = '<a class="ap-chat__foto" href="' + esc(p.u) + '">' + (off > 0 ? '<span class="ap-chat__off">-' + off + '%</span>' : '') + (p.f ? '<img src="' + esc(p.f) + '" alt="' + esc(p.n) + '">' : '') + '</a>' +
        '<small>' + esc(p.m) + '</small><b>' + esc(p.n) + '</b><span class="ap-chat__perche">' + esc(motivo) + '</span>' +
        '<div class="ap-chat__prezzo"><span>' + euro(p.p) + (off > 0 ? '<s>' + euro(p.c) + '</s>' : '') + '</span><button class="ap-chat__carrello" type="button" aria-label="Aggiungi ' + esc(p.n) + ' al carrello">' + CARRELLO + '</button></div>';
      art.querySelector('button').addEventListener('click', function () { metti(this, p, mio); });
      box.appendChild(art);
    });
    return aggiungi(box);
  }

  function dopo(mio) {
    var resto = stato.lista.length - stato.pos;
    var voci = [];
    if (resto > 0) voci.push('Mostrami altri');
    voci.push('Più economici', 'Cambia profumo', 'Ricomincia');
    scelte(voci, function (v) {
      if (v === 'Ricomincia') return avvia();
      if (v === 'Mostrami altri') return altri(mio);
      if (v === 'Più economici') {
        if (stato.budget === 'Sotto 50 euro') return bot(aCaso(GIA) + ' Sono già tutti sotto i 50 euro.', 600, mio).then(function () { dopo(mio); }).catch(function () {});
        stato.budget = 'Sotto 50 euro'; return calcola(mio);
      }
      if (v === 'Cambia profumo') { stato.gustoPrima = stato.gusto; stato.gusto = null; return domanda(mio); }
    });
  }

  function altri(mio) {
    var pezzo = stato.lista.slice(stato.pos, stato.pos + PER_VOLTA);
    stato.pos += pezzo.length;
    if (!pezzo.length) {
      return bot('Ti ho già fatto vedere tutti quelli che fanno per te 😄 Se vuoi cambio profumo o prezzo.', 600, mio).then(function () { dopo(mio); }).catch(function () {});
    }
    var testi = ['Eccone altri, sempre scelti per te.', 'Altri ' + pezzo.length + ' che ti piaceranno.', 'Guarda anche questi.'];
    return bot(aCaso(testi), 700, mio).then(function (intro) {
      mostraCarte(pezzo, mio);
      var fissa = function () { msgs.scrollTop = intro.offsetTop - 12; };
      fissa(); setTimeout(fissa, 400);
      dopo(mio);
    }).catch(function () {});
  }

  /* ===== contatti alla fine: dopo le quattro risposte, prima dei profumi ===== */
  var lead = pannello.querySelector('[data-ap-chat-lead]');
  var boxChat = pannello.querySelector('.ap-chat__box');
  function mem(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function slug(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function riponiLead() { if (lead && lead.parentNode === msgs) { lead.hidden = true; boxChat.appendChild(lead); } var sl = msgs.querySelector('.ap-chat__salta'); if (sl) sl.remove(); }
  function chiediDati(mio) {
    var g = GUSTI[stato.gusto];
    return bot('Fatto! Ho scelto i profumi <b>' + esc(g ? g.dice : 'giusti') + '</b> che fanno per te.', 700, mio)
      .then(function () { return bot('Dove te li mando? Lasciami email e telefono: ti mando la selezione e in regalo hai <b>3 campioncini</b> con il tuo primo ordine.', 900, mio); })
      .then(function () {
        if (mio !== giro || !lead) return;
        var tags = ['chat-yassine', 'gusto-' + slug(stato.gusto), 'chi-' + slug(stato.chi)];
        if (stato.quando && QUANDO[stato.quando]) tags.push('quando-' + slug(stato.quando));
        if (stato.budget && BUDGET[stato.budget]) tags.push('budget-' + slug(stato.budget));
        lead.querySelector('[data-ap-chat-tags]').value = tags.join(',');
        var err = lead.querySelector('[data-ap-chat-lead-err]'); if (err && !stato.riprova) err.remove();
        lead.hidden = false; msgs.appendChild(lead);
        var salta = document.createElement('button'); salta.type = 'button'; salta.className = 'ap-chat__salta'; salta.textContent = 'Mostrameli senza lasciare i dati';
        salta.addEventListener('click', function () { mem('apChatDati', 'saltato'); riponiLead(); io('Mostrameli senza lasciare i dati'); calcola(mio); });
        msgs.appendChild(salta);
        giu();
      });
  }
  function mostraCodice() {
    var c = document.createElement('div'); c.className = 'ap-chat__codice';
    c.innerHTML = '<div><small>Il tuo codice regalo</small><b>YASSINE</b></div><button type="button">Copia</button>';
    c.querySelector('button').addEventListener('click', function (e) {
      var b = e.currentTarget; try { navigator.clipboard.writeText('YASSINE'); } catch (x) {}
      b.textContent = 'Copiato';
    });
    aggiungi(c);
  }
  if (lead) {
    var modulo = lead.querySelector('[data-ap-chat-form]');
    /* all'invio: numero nel formato di Shopify e risposte salvate per riaprire la chat al ritorno */
    modulo.addEventListener('submit', function () {
      var tel = modulo.querySelector('[data-ap-chat-tel]'), out = modulo.querySelector('[data-ap-chat-phone]');
      var n = (tel.value || '').replace(/[^0-9+]/g, '');
      if (n.indexOf('00') === 0) n = '+' + n.slice(2);
      if (n.charAt(0) !== '+') n = '+39' + n;
      out.value = /^\+[1-9][0-9]{7,14}$/.test(n) ? n : '';
      mem('apChatRitorno', JSON.stringify({ chi: stato.chi, gusto: stato.gusto, quando: stato.quando, budget: stato.budget, t: Date.now() }));
    }, true);
  }

  function calcola(mio) {
    if (lead && !stato.dati && !mem('apChatDati')) { stato.dati = true; return chiediDati(mio); }
    var chiave = [stato.chi, stato.gusto, stato.quando, stato.budget].join('|');
    var gia = ricordo.combinazioni[chiave];
    ricordo.combinazioni[chiave] = (gia || 0) + 1;
    var apertura = gia
      ? aCaso(['Queste risposte me le avevi già date 😄 Ti faccio vedere altri profumi, diversi da prima.', 'Stesse scelte di prima! Allora te ne mostro altri che non hai ancora visto.'])
      : aCaso(['Ecco quelli che ti consiglio. Tocca la foto per vederli, oppure il carrello per aggiungerli.', 'Ho scelto questi per te. Scorri per vederli tutti.', 'Secondo me questi fanno per te. Scorri a destra per vederne di più.']);
    return bot('Un attimo che cerco tra i profumi del negozio…', 500, mio).then(function () {
      return classifica();
    }).then(function (lista) {
      if (mio !== giro) return;
      if (gia) {
        var nuovi = lista.filter(function (r) { return !visti[r.p.h]; }), vecchi = lista.filter(function (r) { return visti[r.p.h]; });
        lista = nuovi.concat(vecchi);
      }
      stato.lista = lista; stato.pos = 0;
      if (!lista.length) return bot('Non ho trovato profumi con queste scelte. Proviamo a cambiare qualcosa?', 600, mio).then(function () { dopo(mio); });
      var pezzo = lista.slice(0, PER_VOLTA); stato.pos = pezzo.length;
      return bot(apertura, 800, mio).then(function (intro) {
        mostraCarte(pezzo, mio);
        var fissa = function () { msgs.scrollTop = intro.offsetTop - 12; };
        fissa(); setTimeout(fissa, 400);
        dopo(mio);
      });
    }).catch(function (e) { if (e !== 'fermo' && window.console) console.error('[ap-chat]', e); });
  }

  function domanda(mio) {
    if (!stato.chi) {
      return bot('Per chi è il profumo?', 650, mio).then(function () {
        scelte(Object.keys(CHI), function (v) { stato.chi = v; domanda(mio).catch(function () {}); });
      });
    }
    if (!stato.gusto) {
      return bot(stato.gustoPrima ? 'Va bene, cambiamo. Che profumo ti va adesso?' : 'Che tipo di profumo ti piace?', 650, mio).then(function () {
        scelte(Object.keys(GUSTI), function (v) {
          if (stato.gustoPrima && v === stato.gustoPrima) {
            stato.gusto = v;
            return bot(aCaso(['Hai scelto di nuovo ' + GUSTI[v].dice + ' 😄 Allora non era da cambiare! Te ne mostro altri.', 'Di nuovo ' + GUSTI[v].dice + '? Si vede che è il tuo. Eccone altri.']), 650, mio).then(function () { altri(mio); }).catch(function () {});
          }
          stato.gusto = v; domanda(mio).catch(function () {});
        }, true);
      });
    }
    if (stato.quando === undefined) {
      return bot('Quando lo metteresti di più?', 650, mio).then(function () {
        scelte(Object.keys(QUANDO), function (v) { stato.quando = v; domanda(mio).catch(function () {}); });
      });
    }
    if (stato.budget === undefined) {
      return bot('Ultima domanda: quanto vuoi spendere più o meno?', 650, mio).then(function () {
        scelte(Object.keys(BUDGET), function (v) { stato.budget = v; domanda(mio).catch(function () {}); });
      });
    }
    return calcola(mio);
  }

  function avvia() {
    giro++; var mio = giro;
    var riparti = avviata;
    stato = { chi: null, gusto: null, quando: undefined, budget: undefined, lista: [], pos: 0, gustoPrima: null };
    riponiLead();
    msgs.innerHTML = ''; ultimoBot = false; avviata = true;
    var saluto = riparti
      ? bot('Ripartiamo da capo! Ricordo cosa ti ho già consigliato, così ti faccio vedere anche profumi nuovi.', 500, mio)
      : bot('Ciao, sono <b>Yassine AI</b>, l\'assistente automatico di Yassine, il titolare di Arabian Profumi.', 500, mio)
          .then(function () { return bot('Ti trovo il profumo arabo giusto in quattro domande, tra tutti quelli del negozio. Rispondi toccando le opzioni.', 750, mio); });
    saluto.then(function () { return domanda(mio); }).catch(function () {});
  }

  function apri(e) {
    if (e) e.preventDefault();
    ultimoAttivo = document.activeElement;
    pannello.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (!avviata) avvia();
    var x = pannello.querySelector('[data-ap-chat-chiudi].ap-chat__icona'); if (x) x.focus({ preventScroll: true });
  }
  function chiudi() {
    pannello.hidden = true;
    document.documentElement.style.overflow = '';
    if (ultimoAttivo && ultimoAttivo.focus) ultimoAttivo.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ap-chat], a[href="#trova-profumo"]') : null;
    if (t) apri(e);
  });
  pannello.querySelectorAll('[data-ap-chat-chiudi]').forEach(function (b) { b.addEventListener('click', chiudi); });
  pannello.querySelector('[data-ap-chat-ricomincia]').addEventListener('click', avvia);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pannello.hidden) chiudi(); });
  if (location.hash === '#trova-profumo') apri();

  /* ritorno dopo l'invio dei dati: la chat si riapre sul codice regalo e sui profumi */
  (function () {
    var r = null; try { r = JSON.parse(mem('apChatRitorno') || 'null'); } catch (e) {}
    if (!r || !r.gusto || Date.now() - r.t > 30 * 60 * 1000) return;
    var ok = location.search.indexOf('customer_posted=true') > -1;
    var errore = lead && lead.querySelector('[data-ap-chat-lead-err]');
    if (!ok && !errore) return;
    mem('apChatRitorno', null);
    giro++; var mio = giro;
    stato = { chi: r.chi, gusto: r.gusto, quando: r.quando, budget: r.budget, lista: [], pos: 0, gustoPrima: null };
    riponiLead(); msgs.innerHTML = ''; ultimoBot = false; avviata = true;
    pannello.hidden = false; document.documentElement.style.overflow = 'hidden';
    if (ok) {
      mem('apChatDati', 'ok'); mem('apYassine', '1');
      fetch('/discount/YASSINE', { credentials: 'same-origin' }).catch(function () {});
      bot('Grazie! Ecco il tuo regalo: usa questo codice al pagamento, i <b>3 campioncini</b> li aggiungiamo noi nel carrello.', 400, mio)
        .then(function () { mostraCodice(); return calcola(mio); }).catch(function () {});
    } else {
      stato.riprova = true;
      bot('Mi sa che c\'è un errore nei dati. Ricontrolla email e telefono e riprova.', 400, mio)
        .then(function () { stato.dati = false; return calcola(mio); }).catch(function () {});
    }
  })();

  /* la nuvoletta resta 8 secondi, poi torna ogni 20 secondi per 7 secondi, con una frase diversa */
  var bottone = document.querySelector('.ap-chat-apri');
  if (bottone) {
    var nuvola = bottone.querySelector('.ap-chat-apri__nuvola'), iniziale = nuvola ? nuvola.innerHTML : '';
    var frasi = [iniziale, 'Non sai quale scegliere? <b>Ti aiuto io</b>', 'Cerchi un regalo? <b>Chiedi a Yassine</b>', 'Dolce, oud o fresco? <b>Te lo trovo in 4 domande</b>'];
    var turno = 0;
    setTimeout(function () { bottone.classList.add('is-piccolo'); }, 8000);
    setInterval(function () {
      if (!pannello.hidden) return;
      turno = (turno + 1) % frasi.length;
      if (nuvola) nuvola.innerHTML = frasi[turno];
      bottone.classList.remove('is-piccolo');
      setTimeout(function () { bottone.classList.add('is-piccolo'); }, 7000);
    }, 20000);
  }
})();
